/**
 * @packageDocumentation
 * @module Checks
 */
import { isPrimitive } from '../../others/isPrimitive';
/**
 * Detects if the value is an object type, excluding null or arrays.
 *
 * @param {unknown} value
 *
 * @return {boolean}
 */
export var isObject = function (value) { return (!Array.isArray(value)
    && !isPrimitive(value)
    && !(value instanceof Function)); };
//# sourceMappingURL=isObject.js.map